export const PAGE_QUERY_PARAM = "page";
